import React from 'react'
import PhoneNumberHubPage from "./PhoneNumberHubPage"

function PhoneNumberHubContainer() {
    return (
        <div className="CustomersContainer">
            <PhoneNumberHubPage/>
        </div>
    )
}

export default PhoneNumberHubContainer
